import angular from 'angular';

import { Webhooks } from './webhooks.service.js';
import { WebhooksResource } from './webhooks.resource.js';

angular
  .module('app.global.webhooks', ['app.factory.UserSession', 'ngResource'])
  .service('Webhooks', Webhooks)
  .service('WebhooksResource', WebhooksResource);
